import { useMemo } from "react";
import { useSelector } from "react-redux";

import { getUserId } from "@/lib/common";
import { RootState } from "@/reducers/types";

export const useLoginUser = () => {
  const users = useSelector((state: RootState) => state.layoutApp.layoutMasters.users);

  const loginUser = useMemo(() => {
    const currentLoggedInUserId = getUserId();

    return users.find((user) => user.user_id === currentLoggedInUserId);
  }, [users]);

  return { loginUser };
};
